import AppTemplate from 'templates/App'
import Dashboard from 'components/Dashboard'
import Login from 'components/Login'
import Logout from 'components/Logout'
import ForgotPassword from 'components/ForgotPassword'
import Register from 'components/Register'
import RegisterDetails from 'components/RegisterDetails'
import RegisterSuccess from 'components/RegisterSuccess'
import Verification from 'components/Verification'
import Locations from 'components/locations'
import Jobs from 'components/jobs'
import System from 'components/settings/system'
import Account from 'components/account'
import User from 'components/user'
import Trucks from 'components/trucks'
import Loads from 'components/loads'
import SubmitLoad from 'components/SubmitLoad'
import Invoices from 'components/invoices'
import Payments from 'components/payments'
import Reports from 'components/reports'
import Map from 'components/map'
import Drivers from 'components/drivers'
import Unsubscribe from 'components/Unsubscribe'

export default [
  {
    path: '/',
    component: AppTemplate,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: 'drivers',
        name: 'drivers.index',
        component: Drivers.Index,
        meta: { heading: Drivers.IndexHeading }
      },
      {
        path: 'drivers/create',
        name: 'drivers.create',
        component: Drivers.Form,
        meta: { heading: Drivers.CreateHeading }
      },
      {
        path: 'trucks',
        name: 'trucks.index',
        component: Trucks.Index,
        meta: { heading: Trucks.IndexHeading }
      },
      {
        path: 'trucks/create',
        name: 'trucks.create',
        component: Trucks.Form,
        meta: { heading: Trucks.CreateHeading }
      },
      {
        path: 'trucks/:id',
        name: 'trucks.edit',
        component: Trucks.Form,
        meta: { heading: Trucks.EditHeading }
      },
      {
        path: 'jobs',
        name: 'jobs.index',
        component: Jobs.Index,
        meta: { heading: Jobs.IndexHeading }
      },
      {
        path: 'jobs/create',
        name: 'jobs.create',
        component: Jobs.Form,
        meta: { heading: Jobs.CreateHeading }
      },
      {
        path: 'jobs/:id',
        name: 'jobs.show',
        component: Jobs.Show,
        meta: { heading: Jobs.ShowHeading }
      },
      {
        path: 'jobs/:id/edit',
        name: 'jobs.edit',
        component: Jobs.Form,
        meta: { heading: Jobs.EditHeading }
      },
      {
        path: 'job-board',
        name: 'job-board.index',
        component: Jobs.JobBoard,
        meta: { heading: Jobs.JobBoardHeading }
      },
      {
        path: 'job-requests',
        name: 'jobs.requests',
        component: Jobs.Requests,
        meta: { heading: Jobs.RequestsHeading }
      },
      {
        path: 'job-requests/:id/:action?',
        name: 'jobs.requests.view',
        component: Jobs.Requests,
        meta: { heading: Jobs.RequestsHeading }
      },
      {
        path: 'loads',
        name: 'loads.index',
        component: Loads.Index,
        meta: { heading: Loads.IndexHeading }
      },
      {
        path: 'loads/:id',
        name: 'loads.show',
        component: Loads.Show,
        meta: { heading: Loads.ShowHeading }
      },
      {
        path: 'load-requests',
        name: 'loads.requests',
        component: Loads.Requests,
        meta: { heading: Loads.RequestsHeading }
      },
      {
        path: 'load-requests/:id/:action?',
        name: 'loads.requests.view',
        component: Loads.Requests,
        meta: { heading: Loads.RequestsHeading }
      },
      {
        path: 'load-check',
        name: 'load-check.index',
        component: Loads.LoadChecksList,
        meta: { heading: Loads.LoadChecksHeading }
      },
      {
        path: 'locations',
        name: 'locations.index',
        component: Locations.Index,
        meta: { heading: Locations.IndexHeading }
      },
      {
        path: 'locations/create',
        name: 'locations.create',
        component: Locations.Form,
        meta: { heading: Locations.CreateHeading }
      },
      {
        path: 'locations/:id',
        name: 'locations.edit',
        component: Locations.Form,
        meta: { heading: Locations.EditHeading }
      },
      {
        path: 'settings/system',
        name: 'settings.system',
        component: System.Index,
        meta: { heading: System.IndexHeading }
      },
      {
        path: 'settings/public-job',
        name: 'settings.public-job',
        component: System.PublicJob,
        meta: { heading: System.PublicJobHeading }
      },
      {
        path: 'settings/xero',
        name: 'settings.xero',
        component: System.Xero,
        meta: { heading: System.XeroHeading }
      },
      {
        path: 'settings/commodities',
        name: 'settings.commodities',
        component: System.Commodities,
        meta: { heading: System.CommoditiesHeading }
      },
      {
        path: 'account/settings',
        name: 'account.settings',
        component: User.Form,
        meta: { heading: Account.SettingsHeading }
      },
      {
        path: 'account/credit-notes',
        name: 'account.credit-notes',
        component: User.CreditNotes,
        meta: { heading: User.CreditNotesHeading }
      },
      {
        path: 'account/notifications',
        name: 'account.notifications',
        component: User.Notifications,
        meta: { heading: User.NotificationsHeading }
      },
      {
        path: 'account/users',
        name: 'account.users',
        component: User.AccountUsersList,
        meta: { heading: User.AccountUsersHeading }
      },
      {
        path: 'account/users/create',
        name: 'account.users.create',
        component: User.AccountUserForm,
        meta: { heading: User.AccountUserHeading }
      },
      {
        path: 'account/users/:childId',
        name: 'account.users.edit',
        component: User.AccountUserForm,
        meta: { heading: User.AccountUserHeading }
      },
      {
        path: 'drivers/:id',
        name: 'drivers.edit',
        component: User.DriverForm,
        meta: { heading: User.DriverHeading }
      },
      {
        path: 'users/pending',
        name: 'users.pending',
        component: User.PendingUsers,
        meta: { heading: User.PendingUsersHeading }
      },
      {
        path: 'users/:id',
        name: 'users.edit',
        component: User.Form,
        meta: { heading: User.EditHeading }
      },
      {
        path: 'users/:id/overview',
        name: 'users.overview',
        component: User.AdminOverview
      },
      {
        path: 'users/:id/credit-notes',
        name: 'users.credit-notes',
        component: User.CreditNotes,
        meta: { heading: User.CreditNotesHeading }
      },
      {
        path: 'users/:id/account-users',
        name: 'users.account-users',
        component: User.AccountUsersList,
        meta: { heading: User.AccountUsersHeading }
      },
      {
        path: 'account/:id/users/create',
        name: 'account.parent.users.create',
        component: User.AccountUserForm,
        meta: { heading: User.AccountUserHeading }
      },
      {
        path: 'account/:id/users/:childId',
        name: 'account.parent.users.edit',
        component: User.AccountUserForm,
        meta: { heading: User.AccountUserHeading }
      },
      {
        path: 'users',
        name: 'users.index',
        component: User.Index,
        meta: { heading: User.IndexHeading }
      },
      {
        path: 'invoices',
        name: 'invoices.index',
        component: Invoices.Index,
        meta: { heading: Invoices.IndexHeading }
      },
      {
        path: 'invoices/:id/:action?',
        name: 'invoices.show',
        component: Invoices.Show,
        meta: { heading: Invoices.ShowHeading }
      },
      {
        path: 'payments',
        name: 'payments.index',
        component: Payments.Index,
        meta: { heading: Payments.IndexHeading }
      },
      {
        path: 'payments/:id',
        name: 'payments.show',
        component: Payments.Show,
        meta: { heading: Payments.ShowHeading }
      },
      {
        path: 'reports',
        name: 'reports.index',
        component: Reports.Index,
        meta: { heading: Reports.IndexHeading }
      },
      {
        path: 'map',
        name: 'map',
        component: Map.Index,
        meta: { heading: Map.IndexHeading }
      }
    ]
  },
  {
    path: '/view-payment/:id',
    name: 'view-payment',
    component: Payments.ShowPublic,
    meta: { requiresAuth: false }
  },
  {
    path: '/view-invoice/:id',
    name: 'view-invoice',
    component: Invoices.ShowPublic,
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    alias: '/set-password',
    name: 'auth.forgot',
    component: ForgotPassword,
    meta: { requiresAuth: false }
  },
  {
    path: '/logout',
    name: 'auth.logout',
    component: Logout,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'auth.login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'auth.register',
    component: Register,
    meta: { requiresAuth: false }
  },
  {
    path: '/register/account-details',
    name: 'auth.details',
    component: RegisterDetails,
    meta: { requiresAuth: true }
  },
  {
    path: '/register/success',
    name: 'auth.success',
    component: RegisterSuccess,
    meta: { requiresAuth: true }
  },
  {
    path: '/verification',
    name: 'auth.verification',
    component: Verification,
    meta: { requiresAuth: false }
  },
  {
    path: '/submit-load',
    name: 'submit-load',
    component: SubmitLoad,
    meta: { requiresAuth: false }
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    component: Unsubscribe,
    meta: { requiresAuth: false }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js